module.exports = __webpack_public_path__ + "img/ALLOSURVIE_Badge_Logo_FR.9791ae36.png";